module.exports = __webpack_public_path__ + "assets/img/Compra-a-diferentes-proveedores-en-un-mismo-pedido-5.fc2aa333.png";